export const quiz = {
  landing: {
    headline: 'Find out if AG1 is right for you',
    body: "This short quiz is designed to help you learn how AG1 can support your health journey. Whether you're looking to build better habits, simplify your routine, or invest in your foundational nutrition, we’ll help you see how AG1 could fit into your day.",
    bodySubtext: 'Let’s get started and explore what’s possible.',
    caption: 'This tool is not intended to diagnose or treat any condition',
    start: 'Start Now'
  },
  chart: {
    title: 'Get started with your AG1 journey for less than $3/day!',
    subtitle:
      'AG1 Next Gen provides 75+ vitamins, probiotics, and whole food sourced ingredients to help establish the base for mental and physical health without compromising on quality.*',
    otpCaption: 'FIRST TIME PURCHASE INCLUDES:',
    footnote: 'Value of one-time purchase'
  },
  tooltip: {
    title: 'DID YOU KNOW?'
  },
  ensureModal: {
    title: 'Still unsure?',
    subtitle: 'See what others are saying about the benefits of AG1',
    reviews: 'Read Reviews',
    reject: 'No Thanks'
  },
  processModal: {
    title: 'Get the scoop',
    subtitle:
      'When you sign up for AG1 news you get access to top tips, expert advice, and the latest in health science.',
    signUpText: 'Sign Up Now',
    signUpSuccess: 'Thanks, you are in!',
    signUpReject: 'No Thanks'
  },
  policy: {
    title:
      'By entering your email you agree to receive marketing communications from AG1 and this information will be processed according to our',
    button: 'Privacy Policy'
  },
  valueChart: {
    title: 'Totally get it – you want bang for your buck. ',
    subtitle:
      'One scoop of AG1 replaces a multivitamin, probiotic, adaptogen supplements, and more.<br />' +
      '<br />Buying all that separately could cost more — and mean a lot of pills to swallow. Plus, unlike most supplements, AG1 Next Gen is backed by four clinical trials and is NSF Certified for Sport.<sup>1-4</sup>',
    tableHead1: 'AG1 can replace',
    tableHead2: 'Cost per month',
    caption: 'Based on current available data for average industry prices of premium supplements',
    buttonText: 'Continue'
  },
  results: {
    button: 'Try Now'
  }
};
